// list of Google fonts to show in the dropdown.
// Add/remove any font name from Google Fonts here.
// Format: { name: "Poppins", css: "'Poppins', sans-serif", weights: "300,400,600,800" }
export const fonts = [
  { name: "Poppins", css: "'Poppins', sans-serif", weights: "300,400,600,800" },
  { name: "Roboto", css: "'Roboto', sans-serif", weights: "300,400,700,900" },
  { name: "Montserrat", css: "'Montserrat', sans-serif", weights: "300,400,600,800" },
  { name: "Open Sans", css: "'Open Sans', sans-serif", weights: "300,400,600,800" },
  { name: "Lato", css: "'Lato', sans-serif", weights: "300,400,700" },
  { name: "Inter", css: "'Inter', sans-serif", weights: "300,400,600,700,800" },
  { name: "Nunito", css: "'Nunito', sans-serif", weights: "300,400,700" },
  { name: "Raleway", css: "'Raleway', sans-serif", weights: "300,400,600,700" },
  { name: "Merriweather", css: "'Merriweather', serif", weights: "300,400,700,900" },
  { name: "Playfair Display", css: "'Playfair Display', serif", weights: "400,700,900" },
  { name: "Fira Code", css: "'Fira Code', monospace", weights: "300,400,500,700" },
  { name: "Space Mono", css: "'Space Mono', monospace", weights: "400,700" },
  { name: "PT Sans", css: "'PT Sans', sans-serif", weights: "400,700" },
  { name: "PT Serif", css: "'PT Serif', serif", weights: "400,700" },
  { name: "Rubik", css: "'Rubik', sans-serif", weights: "300,400,500,700,900" },
  { name: "Karla", css: "'Karla', sans-serif", weights: "300,400,700" },
  { name: "Kanit", css: "'Kanit', sans-serif", weights: "300,400,700" },
  { name: "Josefin Sans", css: "'Josefin Sans', sans-serif", weights: "300,400,700" },
  { name: "PT Sans Narrow", css: "'PT Sans Narrow', sans-serif", weights: "400,700" },
  { name: "Bebas Neue", css: "'Bebas Neue', cursive", weights: "400" },
  { name: "Dancing Script", css: "'Dancing Script', cursive", weights: "400,700" },
  { name: "Cabin", css: "'Cabin', sans-serif", weights: "400,700" },
  { name: "Arvo", css: "'Arvo', serif", weights: "400,700" },
  { name: "Noto Sans", css: "'Noto Sans', sans-serif", weights: "400,700" },
  { name: "Noto Serif", css: "'Noto Serif', serif", weights: "400,700" },
  { name: "Ubuntu", css: "'Ubuntu', sans-serif", weights: "300,400,700" },
  { name: "Chivo", css: "'Chivo', sans-serif", weights: "300,400,700" },
  { name: "Manrope", css: "'Manrope', sans-serif", weights: "200,300,400,600,700,800" },
  { name: "Muli", css: "'Muli', sans-serif", weights: "300,400,700" },
  { name: "Quicksand", css: "'Quicksand', sans-serif", weights: "300,400,700" },
  { name: "Play", css: "'Play', sans-serif", weights: "400,700" },
  { name: "Anton", css: "'Anton', sans-serif", weights: "400" },
  { name: "Lobster", css: "'Lobster', cursive", weights: "400" },
  { name: "Satisfy", css: "'Satisfy', cursive", weights: "400" },
  { name: "Zilla Slab", css: "'Zilla Slab', serif", weights: "300,400,700" },
  { name: "Serif", css: "serif", weights: "400" } // fallback example
];
